/* ============================================================
 * 枚举：平台 & 渠道来源
 * ============================================================ */
/** QueryInfoParams.platform — 美团/点评平台标识 */
export var Platform;
(function (Platform) {
    Platform[Platform["MEITUAN"] = 1] = "MEITUAN";
    Platform[Platform["DIANPING"] = 2] = "DIANPING";
})(Platform || (Platform = {}));
/** QueryInfoParams.source — 渠道来源 */
export var Source;
(function (Source) {
    Source[Source["MEITUAN_APP"] = 1] = "MEITUAN_APP";
    Source[Source["DIANPING_APP"] = 2] = "DIANPING_APP";
    Source[Source["WECHAT_MEITUAN_MINI"] = 3] = "WECHAT_MEITUAN_MINI";
    Source[Source["WECHAT_HOTEL_MINI"] = 4] = "WECHAT_HOTEL_MINI";
    Source[Source["WECHAT_DIANPING_MINI"] = 5] = "WECHAT_DIANPING_MINI";
    Source[Source["UNKNOWN"] = 999] = "UNKNOWN";
})(Source || (Source = {}));
/** RiskRequest.operateSource — 风控操作来源（isMRN='App', isWeb='H5'） */
export var RiskOperateSource;
(function (RiskOperateSource) {
    RiskOperateSource["PC"] = "PC";
    RiskOperateSource["H5"] = "H5";
    RiskOperateSource["APP"] = "App";
    RiskOperateSource["WX"] = "WX";
})(RiskOperateSource || (RiskOperateSource = {}));
/** RiskRequest.platform — 风控平台标识（由 getRiskParams 自动填充） */
export var RiskPlatform;
(function (RiskPlatform) {
    RiskPlatform[RiskPlatform["ANDROID"] = 4] = "ANDROID";
    RiskPlatform[RiskPlatform["IOS"] = 5] = "IOS";
    RiskPlatform[RiskPlatform["WECHAT_MINI"] = 13] = "WECHAT_MINI";
})(RiskPlatform || (RiskPlatform = {}));
/** 任务类型 */
export var TaskType;
(function (TaskType) {
    TaskType[TaskType["ORDER_TASK"] = 1001] = "ORDER_TASK";
    // R007：下单任务（本次新增取值）
    TaskType[TaskType["INVITE_TASK"] = 1002] = "INVITE_TASK";
    // 邀请助力任务
    TaskType[TaskType["BROWSE_TASK"] = 1003] = "BROWSE_TASK"; // R007：浏览任务（本次新增取值）
})(TaskType || (TaskType = {}));
/** 任务状态 */
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus[TaskStatus["UNFINISHED"] = 2] = "UNFINISHED";
    // 未完成
    TaskStatus[TaskStatus["FINISHED"] = 3] = "FINISHED";
    // 已完成
    TaskStatus[TaskStatus["IMPOSSIBLE"] = -1] = "IMPOSSIBLE"; // 不可完成
})(TaskStatus || (TaskStatus = {}));
/** 榜单状态 */
export var RankStatus;
(function (RankStatus) {
    RankStatus[RankStatus["RANKING"] = 1] = "RANKING";
    // 冲榜中
    RankStatus[RankStatus["CALCULATING"] = 2] = "CALCULATING";
    // 冲榜结束排名计算中
    RankStatus[RankStatus["REWARD_CALCULATED"] = 3] = "REWARD_CALCULATED"; // 冲榜奖励计算完成
})(RankStatus || (RankStatus = {}));
/** 城市标签（后端 CardGroupExtra.cityTag 码值） */
export var CityTag;
(function (CityTag) {
    CityTag[CityTag["Water"] = 1] = "Water"; // 玩水
})(CityTag || (CityTag = {}));
/** R007：推荐供给(3.18) client 入参 —— 设备端（对齐后端枚举，仅取用到的值） */
export var RecClient;
(function (RecClient) {
    RecClient[RecClient["UNKNOWN"] = 0] = "UNKNOWN";
    RecClient[RecClient["ANDROID"] = 4] = "ANDROID";
    RecClient[RecClient["IPHONE"] = 5] = "IPHONE";
})(RecClient || (RecClient = {}));
/** R007：推荐供给(3.18) source4Homestay 入参 —— 民宿来源端（对齐后端枚举） */
export var RecHomestaySource;
(function (RecHomestaySource) {
    /** 美团APP */
    RecHomestaySource["MT"] = "group";
    RecHomestaySource["UNKNOWN"] = "unknown";
})(RecHomestaySource || (RecHomestaySource = {}));
